export default "__VITE_ASSET__c542a9f4__"